import React from "react";
import LogoImg from "../../assets/icons/cubeGlobalLogo.png";
import { FaMapMarkerAlt } from "react-icons/fa";
import { MdPhoneIphone } from "react-icons/md";
import ContactMethod from "../headerComponents/contactMethodComponent";
import "./footerMediaInformations.scss";

const FooterMediaInformations = () => {
  return (
    <div className="footer-media-informations">
      <img src={LogoImg} alt="Logo" className="footer-logo" />

      <ContactMethod
        icon={FaMapMarkerAlt}
        text={
          "Arthur Evelyn Building, Suite 5, Main Street, Charlestown, Nevis"
        }
        responsiveTextColor={"white"}
      />

      <ContactMethod
        icon={MdPhoneIphone}
        text={"+381-60-3335726"}
        responsiveTextColor={"white"}
      />

      <ContactMethod
        // icon={MdPhoneIphone}
        text={"info@cubeglobalservices.com"}
        responsiveTextColor={"white"}
      />
    </div>
  );
};

export default FooterMediaInformations;
